import React, { Component, Fragment } from "react";
import * as actionTypes from "../../../store/Actions/actions";
import * as UTILS from "../../../utils/Utils";
import "./Video.scss";
import Library from "../../Modal/Library/Library";
import VideoModal from "./VideoModal";
import cloneDeep from "lodash.clonedeep";
import { connect } from "react-redux";
import Popup from "../../Modal/Popup";
import libraryIcon from "../../../assets/images/libraryVideo.svg";
import CloneICON from "../../../assets/images/clone.svg";
import link from "../../../assets/images/hyperlink.svg";
import AddPlus from "../../../assets/images/add_video.svg";
import AddPlusActive from "../../../assets/images/add_video_active.svg";
import noImage from "../../../assets/images/noimage.png";

class VideoElement extends Component {
  constructor(props) {
    super(props);
    this.widthInputVideo = React.createRef();
    this.state = {
      editVidID: null,
      videoURL: false,
      enableContentModal: false,
      invalidVideo: false,
      notValidURL: false,
      options: false,
      embedVideoToggle: false,
      embedVideoInput: null,
      embedVideo: this.props.element.embedVideo
        ? this.props.element.embedVideo
        : null,
      videoURL_ADDRESS:
        this.props.video_url !== null ? this.props.video_url : "",
      maxWidthRange: null,
      resizeWidth: false,
    };
  }
  componentDidMount = () => {
    this.setState({
      maxWidthRange: this.widthInputVideo.current.clientWidth,
      invalidVideo: false,
    });
    this.setState({
      videoURL_ADDRESS:
        this.props.video_url !== null ? this.props.video_url : "",
    });
    if (this.props.video_url) {
      // this.fetchThumb(this.props.video_url);
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.element.embedVideo !== prevState.embedVideo) {
      return { embedVideo: nextProps.element.embedVideo };
    }
    return false;
  }
  enableModal = (e) => {
    this.setState(
      {
        enableContentModal: true,
      },
      () => {
        let contentModalDiv = document.querySelector("body .contentModal");
        !contentModalDiv && document.body.classList.contains("my-class-name")
          ? null
          : (document.body.className += " contentModalEnabled");
      }
    );
  };
  closeModal = () => {
    this.setState(
      {
        enableContentModal: false,
      },
      () => {
        document.body.classList.remove("contentModalEnabled");
      }
    );
  };
  // validateVimeo = ( urlValue ) => {

  // }

  pushURLVideo = (
    videoID,
    videoTHUMB,
    hostID,
    hostTHUMB,
    nullID,
    nullTHUMB,
    videoURL
  ) => {
    const layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item[hostID] = videoID;
        item[hostTHUMB] = videoTHUMB;
        item[nullID] = null;
        item[nullTHUMB] = null;
        item.type = "URL";
        item.src = null;
        item.srcID = null;
        item.video_url = videoURL;
        item.embedVideo = null;
        item.embedVideoThumb = null;
      },
      (colItem) => {
        colItem[hostID] = videoID;
        colItem[hostTHUMB] = videoTHUMB;
        colItem[nullID] = null;
        colItem[nullTHUMB] = null;
        colItem.type = "URL";
        colItem.src = null;
        colItem.srcID = null;
        colItem.video_url = videoURL;
        colItem.embedVideo = null;
        colItem.embedVideoThumb = null;
      },
      (colItemNested) => {
        colItemNested[hostID] = videoID;
        colItemNested[hostTHUMB] = videoTHUMB;
        colItemNested[nullID] = null;
        colItemNested[nullTHUMB] = null;
        colItemNested.type = "URL";
        colItemNested.src = null;
        colItemNested.srcID = null;
        colItemNested.video_url = videoURL;
        colItemNested.embedVideo = null;
        colItemNested.embedVideoThumb = null;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  fetchThumb = (url) => {
    let video_id = null;
    let thumbURL = null;
    let hostID = null;
    let hostTHUMB = null;
    let nullID = null;
    let nullTHUMB = null;
    let video_url = null;

    if (url.indexOf("youtube.com/watch?v") > -1 && UTILS.ValidURL(url)) {
      var a = url.split("v=")[1];
      a = a != undefined ? a : url.split("youtube/")[1];

      video_id = a.split("&")[0];
      video_url = url;
      hostID = "youtubeID";
      hostTHUMB = "youtubeTHUMB";
      nullID = "vimeoID";
      nullTHUMB = "vimeoTHUMB";
      this.setState({
        notValidURL: false,
      });
      thumbURL = "https://img.youtube.com/vi/" + video_id + "/mqdefault.jpg";

      // this.validVideoId(video_id);
      screenY;
      !this.state.invalidVideo &&
        !this.state.notValidURL &&
        this.pushURLVideo(
          video_id,
          thumbURL,
          hostID,
          hostTHUMB,
          nullID,
          nullTHUMB,
          video_url
        );
    } else if (url.indexOf("vimeo.com/") > -1) {
      function getID(url) {
        var match = /vimeo.*\/(\d+)/i.exec(url);
        if (match) {
          return match[1];
        }
      }
      video_id = getID(url);
      video_url = url;
      hostID = "vimeoID";
      hostTHUMB = "vimeoTHUMB";
      nullID = "youtubeID";
      nullTHUMB = "youtubeTHUMB";


      fetch(`https://api.vimeo.com/videos/${video_id}/pictures`, {
        method: "GET",
        headers: {
          Accept: "application/vnd.vimeo.*+json;version=3.4",
          "Accept-Encoding": "gzip,deflate,br",
          Authorization: `bearer cc3f61f10ca008b9b038c7f7db9ada37`,
          "Content-Type": "application",
          Connection: "keep-alive",
          Host: "api.vimeo.com",
          // "Access-Control-Allow-Origin": "*",
        },
      })
        .then((response) => response.json())
        .then(
          (json) => {
            this.setState({
              invalidVideo: false,
            });
            thumbURL = json.data[0].sizes[6].link;
            !this.state.invalidVideo &&
              this.pushURLVideo(
                video_id,
                thumbURL,
                hostID,
                hostTHUMB,
                nullID,
                nullTHUMB,
                video_url
              );
          },
          (err) => {
            this.setState({
              invalidVideo: true,
            });
          }
        );
    } else if (
      UTILS.ValidURL(url) == false ||
      /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/.test(url) ==
      false
    ) {
      this.setState({
        notValidURL: true,
        invalidVideo: true,
      });
    }
  };

  resetURL = (val) => {
    this.setState({
      videoURL_ADDRESS: val,
    });
  };
  videoOption = (id) => {
    this.setState(
      {
        options: this.state.options ? null : id,
      }
    );
  };
  addVideo = (elementID) => {
    this.setState({
      videoClicked: elementID,
      options: null,
    });
  };

  render() {
    let style = this.props.vidStyle;
    const deleteSelectedFile = this.props.deleteSelectedFile;
    return (
      <div
        className="video-wrapper"
        id={this.props.ID}
        ref={this.widthInputVideo}
      >
        {!this.props.element.dataModule && (
          <div className="actionControl">
            <button
              className="button text-setting"
              onClick={() => {
                this.setState({
                  editVidID: this.props.ID,
                });
              }}
            >
              Video Settings
            </button>
            <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
              <img src={CloneICON} />
            </button>
            <button
              className="delete-item"
              onClick={() => { this.props.deleteElement(this.props.element.id) }}
              id={this.props.ID}
            >
              <i className="far fa-trash-alt" />
            </button>
          </div>
        )}
        {this.state.options == this.props.ID ? (
          <Popup
            width="560"
            header="Choose Video Upload Option"
            closePopup={() => {
              this.videoOption();
              this.setState({
                videoURL: false,
                notValidURL: false,
                videoURL_ADDRESS:
                  this.props.video_url !== null ? this.props.video_url : "",
              });
            }}
            close={() => {
              this.videoOption();
              this.setState({
                videoURL: false,
                notValidURL: false,
                videoURL_ADDRESS:
                  this.props.video_url !== null ? this.props.video_url : "",
              });
            }}
          >
            <ul className="addVideoFrom">
              <li
                onClick={() => {
                  this.videoOption();

                  this.setState({
                    videoURL: true,
                  });
                }}
              >
                <img src={link} />
                <span>Choose from URL</span>
              </li>
              <li
                onClick={() => {
                  this.addVideo(this.props.ID);
                }}
              >
                <img src={libraryIcon} />
                <span>Choose from library</span>
              </li>
            </ul>
          </Popup>
        ) : null}
        {this.state.videoURL ? (
          <Popup
            width="560"
            header="Add Video from URL"
            closePopup={() => {
              this.videoOption();
              this.setState({
                videoURL: false,
                notValidURL: false,
                videoURL_ADDRESS:
                  this.props.video_url !== null ? this.props.video_url : "",
              });
            }}
            close={() => {
              this.videoOption();
              this.setState({
                videoURL: false,
                notValidURL: false,
                videoURL_ADDRESS:
                  this.props.video_url !== null ? this.props.video_url : "",
              });
            }}
          >
            <div className="addVideoURL modalContentWrapper">
              <label>
                Upload a Video URL
                <small> (Only supports YouTube and Vimeo URLs)</small>
              </label>
              <small>
                CAUTION: Videos added from a URL outside the Flimp Platform will
                disable tracking/reporting features due to the use of an
                external video player
              </small>
              <input
                type="text"
                defaultValue={this.state.videoURL_ADDRESS}
                style={
                  this.state.notValidURL
                    ? {
                      borderColor: "red",
                      borderWidth: "1px",
                      borderType: "solid",
                    }
                    : {}
                }
                onChange={(e) => {
                  this.setState({
                    videoURL_ADDRESS: e.target.value,
                  });
                }}
                placeholder="https://www.youtube.com/watch?v=ZL4NhOyLZlA"
              />
              <button
                className="boxShadowOnHover"
                onClick={() => {
                  this.setState(
                    {
                      notValidURL: false,
                    },
                    () => {
                      this.fetchThumb(this.state.videoURL_ADDRESS);
                    }
                  );
                }}
              >
                Add Video URL
              </button>
              {this.state.invalidVideo && (
                <span className="invalidVideo">Video URL is not valid</span>
              )}
            </div>
          </Popup>
        ) : (
          ""
        )}
        {this.state.editVidID == this.props.ID && (
          <VideoModal
            maxWidthRange={this.state.maxWidthRange}
            showChaptersToggle={this.props.showChaptersToggle}
            hideVideoSetting={() => {
              this.setState({
                editVidID: null,
                notValidURL: false,
                videoURL_ADDRESS:
                  this.props.video_url !== null ? this.props.video_url : "",
              });
            }}
            if_src={this.props.if_src}
            youtubeTHUMB={this.props.youtubeTHUMB}
            vimeoTHUMB={this.props.vimeoTHUMB}
            label={this.props.label}
            videoTitle={this.props.element.videoTitle}
            widthInputVideo={this.widthInputVideo}
            marginTop={this.props.marginTop}
            marginBottom={this.props.marginBottom}
            videoMarginUnit={this.props.videoMarginUnit}
            videoWidthUnit={this.props.videoWidthUnit}
            changeVideo={() => {
              this.addVideo(this.props.ID);
            }}
            fetchThumb={this.fetchThumb}
            videoURL_ADDRESS={this.state.videoURL_ADDRESS}
            layoutTitle={this.props.layoutTitle}
            VideoWidth={this.props.VideoWidth}
            control={this.props.control}
            autoplay={this.props.autoplay}
            modal={this.props.modal}
            chapters={this.props.chapters}
            layout={this.props.layout}
            ID={this.props.ID}
          >
            <div className="addVideoURL">
              <label>
                Video URL <small>(Youtube or Vimeo)</small>
              </label>
              <small>
                CAUTION: Videos added from a URL outside the Flimp Platform will
                disable tracking/reporting features due to the use of an
                external video player
              </small>
              <input
                type="text"
                style={
                  this.state.notValidURL
                    ? {
                      borderColor: "red",
                      borderWidth: "1px",
                      borderType: "solid",
                    }
                    : {}
                }
                defaultValue={this.state.videoURL_ADDRESS}
                onChange={(e) => {
                  this.setState({
                    videoURL_ADDRESS: e.target.value,
                  });
                }}
                placeholder="https://www.youtube.com/watch?v=ZL4NhOyLZlA"
              />
              <button
                onClick={() => {
                  this.setState(
                    {
                      notValidURL: false,
                    },
                    () => {
                      this.fetchThumb(this.state.videoURL_ADDRESS);
                    }
                  );
                }}
              >
                Add Video URL
              </button>
              {this.state.invalidVideo && (
                <span className="invalidVideo">Video URL is not valid</span>
              )}
            </div>
          </VideoModal>
        )}
        <Fragment>
          {this.props.if_src ? (
            <div className="videoImageWrapper">
              {" "}
              <div
                className="thumbWRAP"
                onClick={
                  this.props.element.dataModule ? this.enableModal : null
                }
                style={{
                  width: "100%",
                  maxWidth:
                    this.props.VideoWidth !== ""
                      ? this.props.VideoWidth +
                      (this.props.videoWidthUnit
                        ? this.props.videoWidthUnit
                        : "px")
                      : "100%",
                }}
              >
                <img
                  onError={(e) => {
                    e.target.src = noImage;
                  }}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    marginTop:
                      this.props.marginTop +
                      (this.props.videoMarginUnit
                        ? this.props.videoMarginUnit
                        : "px"),
                    marginBottom:
                      this.props.marginBottom +
                      (this.props.videoMarginUnit
                        ? this.props.videoMarginUnit
                        : "px"),
                    marginRight:
                      this.props.marginRight +
                      (this.props.videoMarginUnit
                        ? this.props.videoMarginUnit
                        : "px"),
                    marginLeft:
                      this.props.marginLeft +
                      (this.props.videoMarginUnit
                        ? this.props.videoMarginUnit
                        : "px"),
                  }}
                  src={this.props.if_src}
                />
              </div>
            </div>
          ) : this.props.if_src == null &&
            this.props.vimeoTHUMB == null &&
            this.props.youtubeTHUMB == null ? (
            <div
              onClick={this.props.element.dataModule ? this.enableModal : null}
              className={
                "addVideo" + (this.props.if_src ? " " : " ")
              }
            >
              <button
                onClick={() => {
                  this.videoOption(this.props.ID);
                }}
              >
                <img className="normal" src={AddPlus} />
                <img className="active" src={AddPlusActive} />
              </button>
              <span>Add Video</span>
            </div>
          ) : null}
        </Fragment>
        <Fragment>
          {/*Beginning of conditional Video Thumbnail Render based on URL or Library Embed */}
          {this.props.youtubeTHUMB || this.props.vimeoTHUMB ? (
            <div
              className="choosenURL"
              onClick={this.props.element.dataModule ? this.enableModal : null}
            >
              <div
                className="thumbWRAP"
                style={{
                  width: "100%",
                  maxWidth:
                    this.props.VideoWidth !== ""
                      ? this.props.VideoWidth +
                      (this.props.videoWidthUnit
                        ? this.props.videoWidthUnit
                        : "px")
                      : "100%",
                }}
              >
                <img
                  src={
                    this.props.youtubeTHUMB
                      ? this.props.youtubeTHUMB
                      : this.props.vimeoTHUMB
                  }
                  className={
                    this.state.enableContentModal ? "activeElement" : " "
                  }
                  style={{
                    width: "100%",
                    marginTop: this.props.marginTop + "px",
                    marginBottom: this.props.marginBottom + "px",
                    marginRight: this.props.marginRight + "px",
                    marginLeft: this.props.marginLeft + "px",
                  }}
                />
              </div>
            </div>
          ) : null}
        </Fragment>
        {this.state.videoClicked === this.props.ID ? (
          <Library
            selectingContent={true}
            ID={this.props.ID}
            resetURL={this.resetURL}
            selectedFile={this.props.selectedFile}
            modalUpload={this.props.modalUpload}
            toggleUploadPopup={() => {
              this.setState({ videoClicked: null, options: false });
            }}
            dragEntered={this.props.dragEntered}
            dragLeave={this.props.dragLeave}
            loaded={this.props.loaded}
            userID={this.props.userID}
            videoTab={true}
            srcID={this.props.srcID}
            AWSdetails={this.props.AWSdetails}
            sessionID={this.props.sessionID}
            initP={this.props.initP}
            scroll={this.props.scroll}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoElement);
